export default {
	sentenceLength: {
		recommendedWordCount: 25,
	},
};
